import { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { createBanner, deleteBanner, updateBanner } from "../../../api/setting";

function HomeBanner({ bannerColor, bannerTitle, bannerText }) {
  return (
    <div
      className="w-[330px] min-w-[330px] max-w-[330px] mr-4 h-[150px] rounded-[20px] p-4"
      style={{ backgroundColor: bannerColor ?? "#1C2834" }}
    >
      <div className="h-full flex flex-col justify-between w-1/2 text-white font-dmsans whitespace-normal">
        <div className="banner-heading font-bold text-[16px] ">
          {" "}
          {bannerTitle ?? ""}{" "}
        </div>
        <div className="banner-text font-medium text-[12px] leading-[17px]">
          {bannerText ?? ""}{" "}
        </div>
      </div>
    </div>
  );
}

const CreateHomeBanner = ({ handleClose, section = "home" }) => {
  const queryClient = useQueryClient();
  const bannerColors = ["#1C2834", "#27AE60", "#1C86F0"];
  const [visible, setVisible] = useState(false);

  const [color, setColor] = useState("#1C2834");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [position, setPosition] = useState("center");
  const [isActive, setActivate] = useState(false);
  const [actionUrl, setActionUrl] = useState("");
  const [actionType, setActionType] = useState("no-action");

  const mutation = useMutation(createBanner, {
    onSuccess: () => {
      queryClient.invalidateQueries("banners");
      toast.success("Banner added");
      handleClose();
    },
    onError: (e) => {
      toast.error(e.message);
    },
  });

  const onFinish = (e) => {
    e.preventDefault();

    if (actionType === "redirect" && !actionUrl) {
      return toast.error("You must add a url for redirect");
    }

    const data = {
      color,
      title,
      description,
      position,
      isActive,
      actionUrl,
      section,
    };

    mutation.mutate(data);
  };

  useEffect(() => {
    setTimeout(() => {
      setVisible(2);
    }, 200);
  }, []);

  return (
    <div
      className="h-full fixed top-0 right-0"
      style={{ width: "calc(100vw - 260px)" }}
    >
      <div className={"w-full h-full bg-[#00000054] fixed"}></div>
      <div
        className={`relative h-[85%] bg-white top-[50%] translate-y-[-50%] transition-all overflow-hidden ${
          visible ? "w-[80%] opacity-100" : "w-[0%] opacity-50"
        }`}
        style={{ transitionDuration: "500" }}
      >
        <div className="space-y-5 py-10 px-7">
          <div className="flex items-center">
            <div className="m-auto text-[19px] font-bold">Create Banner</div>
            <button
              className="bg-[#1B0A4B] p-1 rounded-[5px] w-fit"
              onClick={handleClose}
            >
              <FaTimes className="text-white " />
            </button>
          </div>
          <div className="w-full h-full flex gap-10 py-5 px-5">
            <div className="w-1/2 space-y-3">
              <div className="font-medium text-[17px] capitalize">
                {section || "Home"} Banner
              </div>
              <HomeBanner
                bannerColor={color}
                bannerTitle={title}
                bannerText={description}
              />
            </div>
            <div className="w-1/2 h-[450px] overflow-y-scroll p-2">
              <div className="space-y-3">
                <div className="text-[#181819E5] text-[15px]">
                  Choose Template
                </div>
                <div className="w-full flex gap-3">
                  {bannerColors.map((v, k) => {
                    return (
                      <div
                        key={k}
                        className={`border-[1px] h-[40px] rounded-[5px] w-full cursor-pointer`}
                        style={{
                          borderColor: v,
                          padding: color == v ? "2px" : "0px",
                        }}
                        onClick={() => setColor(v)}
                      >
                        <div
                          className={`w-full h-full rounded-[5px]`}
                          style={{ backgroundColor: v }}
                        ></div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="space-y-3">
                <div className="text-[#181819E5] text-[15px]">
                  Create banner title
                </div>
                <input
                  type="text"
                  className="w-full text-[14px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg h-[45px] px-4"
                  placeholder="Create banner title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>

              <div className="flex flex-col gap-3">
                <div className="text-[#181819E5] text-[15px]">
                  Create banner text
                </div>
                <textarea
                  type="text"
                  className="w-full text-[14px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg resize-none h-[100px] py-2 px-4 "
                  placeholder="Create banner text"
                  value={description}
                  maxLength={100}
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>

                <div className="ml-auto text-[12px] text-[#7B7B7B]">
                  {description.length}/100
                </div>
              </div>

              <div className="flex flex-col gap-3">
                <div className="text-[#181819E5] text-[14px]">
                  Activate Banner
                </div>
                <div className="flex items-center gap-4 font-inter font-medium text-[#2D2E2C] text-[14px]">
                  <div className="--box-shadow flex items-center gap-4 w-full">
                    <input
                      type="radio"
                      id="banner-active"
                      name="banner-activate"
                      defaultChecked={isActive}
                      onChange={() => setActivate(true)}
                    />
                    <label for="no-action">Yes</label>
                  </div>
                  <div className="--box-shadow flex items-center gap-4 w-full">
                    <input
                      type="radio"
                      id="banner-inactive"
                      name="banner-activate"
                      defaultChecked={isActive}
                      onChange={() => setActivate(false)}
                    />

                    <label for="redirect">No</label>
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-3 mt-2">
                <div className="text-[#181819E5] text-[14px]">
                  Add banner action
                </div>
                <div className="flex items-center gap-4 font-inter font-medium text-[#2D2E2C] text-[14px]">
                  <div className="--box-shadow flex items-center gap-4 w-full">
                    <input
                      type="radio"
                      id="no-action"
                      name="banner-action"
                      defaultChecked={actionType == "no-action"}
                      onChange={() => setActionType("no-action")}
                    />
                    <label for="no-action">No action</label>
                  </div>
                  <div className="--box-shadow flex items-center gap-4 w-full">
                    <input
                      type="radio"
                      id="redirect"
                      name="banner-action"
                      defaultChecked={actionType == "redirect"}
                      onChange={() => setActionType("redirect")}
                    />

                    <label for="redirect">Redirect</label>
                  </div>
                </div>
                {actionType == "redirect" ? (
                  <div className="space-y-3">
                    <div className="">
                      <input
                        type="text"
                        className="w-full text-[14px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg py-2 px-4"
                        placeholder="Add destination link"
                        value={actionUrl}
                        onChange={(e) => setActionUrl(e.target.value)}
                      />
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>

              <div className="flex items-center w-full font-bold text-[14px] gap-5 py-10">
                <button
                  type="button"
                  onClick={onFinish}
                  className={`w-full bg-[#1B0A4B] p-2 rounded-[5px] text-white ${
                    mutation.isLoading ? "animate-pulse" : ""
                  }`}
                >
                  {mutation.isLoading ? "Saving..." : "Save"}
                </button>
                <button
                  type="button"
                  className="w-full bg-[#0000000D] p-2 rounded-[5px]"
                  onClick={handleClose}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const UpdateHomeBanner = ({ handleClose, section = "home", prevBanner }) => {
  const queryClient = useQueryClient();
  const bannerColors = ["#1C2834", "#27AE60", "#1C86F0"];
  const [visible, setVisible] = useState(false);

  const [color, setColor] = useState("#1C2834");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [position, setPosition] = useState("center");
  const [isActive, setActivate] = useState(false);
  const [actionUrl, setActionUrl] = useState("");
  const [actionType, setActionType] = useState("no-action");

  useEffect(() => {
    console.log({ prevBanner });
    if (prevBanner) {
      setColor(prevBanner.color);
      setTitle(prevBanner.title);
      setDescription(prevBanner.description);
      setActivate(prevBanner.isActive);
      setActionUrl(prevBanner.actionUrl);
      setActionType(prevBanner.actionUrl ? "redirect" : "no-action");
    }
  }, [prevBanner]);

  const mutation = useMutation(updateBanner, {
    onSuccess: () => {
      queryClient.invalidateQueries("banners-home");
      queryClient.invalidateQueries("banners-shop");
      toast.success("Banner updated");
      handleClose();
    },
    onError: (e) => {
      toast.error(e.message);
    },
  });

  const onFinish = (e) => {
    e.preventDefault();

    if (actionType === "redirect" && !actionUrl) {
      return toast.error("You must add a url for redirect");
    }

    const data = {
      id: prevBanner._id,
      color,
      title,
      description,
      position,
      isActive,
      actionUrl,
      section,
    };

    mutation.mutate(data);
  };

  useEffect(() => {
    setTimeout(() => {
      setVisible(2);
    }, 200);
  }, []);

  return (
    <div
      className="h-full fixed top-0 right-0"
      style={{ width: "calc(100vw - 260px)" }}
    >
      <div className={"w-full h-full bg-[#00000054] fixed"}></div>
      <div
        className={`relative h-[85%] bg-white top-[50%] translate-y-[-50%] transition-all overflow-hidden ${
          visible ? "w-[80%] opacity-100" : "w-[0%] opacity-50"
        }`}
        style={{ transitionDuration: "500" }}
      >
        <div className="space-y-5 py-10 px-7">
          <div className="flex items-center">
            <div className="m-auto text-[19px] font-bold">Update Banner</div>
            <button
              className="bg-[#1B0A4B] p-1 rounded-[5px] w-fit"
              onClick={handleClose}
            >
              <FaTimes className="text-white " />
            </button>
          </div>
          <div className="w-full h-full flex gap-10 py-5 px-5">
            <div className="w-1/2 space-y-3">
              <div className="font-medium text-[17px] capitalize">
                {section || "Home"} Banner
              </div>
              <HomeBanner
                bannerColor={color}
                bannerTitle={title}
                bannerText={description}
              />
            </div>
            <div className="w-1/2 h-[450px] overflow-y-scroll p-2">
              <div className="space-y-3">
                <div className="text-[#181819E5] text-[15px]">
                  Choose Template
                </div>
                <div className="w-full flex gap-3">
                  {bannerColors.map((v, k) => {
                    return (
                      <div
                        key={k}
                        className={`border-[1px] h-[40px] rounded-[5px] w-full cursor-pointer`}
                        style={{
                          borderColor: v,
                          padding: color == v ? "2px" : "0px",
                        }}
                        onClick={() => setColor(v)}
                      >
                        <div
                          className={`w-full h-full rounded-[5px]`}
                          style={{ backgroundColor: v }}
                        ></div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="space-y-3">
                <div className="text-[#181819E5] text-[15px]">
                  Create banner title
                </div>
                <input
                  type="text"
                  className="w-full text-[14px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg h-[45px] px-4"
                  placeholder="Create banner title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>

              <div className="flex flex-col gap-3">
                <div className="text-[#181819E5] text-[15px]">
                  Create banner text
                </div>
                <textarea
                  type="text"
                  className="w-full text-[14px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg resize-none h-[100px] py-2 px-4 "
                  placeholder="Create banner text"
                  value={description}
                  maxLength={100}
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>

                <div className="ml-auto text-[12px] text-[#7B7B7B]">
                  {description.length}/100
                </div>
              </div>

              <div className="flex flex-col gap-3">
                <div className="text-[#181819E5] text-[14px]">
                  Activate Banner
                </div>
                <div className="flex items-center gap-4 font-inter font-medium text-[#2D2E2C] text-[14px]">
                  <div className="--box-shadow flex items-center gap-4 w-full">
                    <input
                      type="radio"
                      id="banner-active"
                      name="banner-activate"
                      defaultChecked={isActive}
                      onChange={() => setActivate(true)}
                    />
                    <label for="no-action">Yes</label>
                  </div>
                  <div className="--box-shadow flex items-center gap-4 w-full">
                    <input
                      type="radio"
                      id="banner-inactive"
                      name="banner-activate"
                      defaultChecked={isActive}
                      onChange={() => setActivate(false)}
                    />

                    <label for="redirect">No</label>
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-3 mt-2">
                <div className="text-[#181819E5] text-[14px]">
                  Add banner action
                </div>
                <div className="flex items-center gap-4 font-inter font-medium text-[#2D2E2C] text-[14px]">
                  <div className="--box-shadow flex items-center gap-4 w-full">
                    <input
                      type="radio"
                      id="no-action"
                      name="banner-action"
                      defaultChecked={actionType == "no-action"}
                      onChange={() => setActionType("no-action")}
                    />
                    <label for="no-action">No action</label>
                  </div>
                  <div className="--box-shadow flex items-center gap-4 w-full">
                    <input
                      type="radio"
                      id="redirect"
                      name="banner-action"
                      defaultChecked={actionType == "redirect"}
                      onChange={() => setActionType("redirect")}
                    />

                    <label for="redirect">Redirect</label>
                  </div>
                </div>
                {actionType == "redirect" ? (
                  <div className="space-y-3">
                    <div className="">
                      <input
                        type="text"
                        className="w-full text-[14px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg py-2 px-4"
                        placeholder="Add destination link"
                        value={actionUrl}
                        onChange={(e) => setActionUrl(e.target.value)}
                      />
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>

              <div className="flex items-center w-full font-bold text-[14px] gap-5 py-10">
                <button
                  type="button"
                  onClick={onFinish}
                  className={`w-full bg-[#1B0A4B] p-2 rounded-[5px] text-white ${
                    mutation.isLoading ? "animate-pulse" : ""
                  }`}
                >
                  {mutation.isLoading ? "Saving..." : "Save"}
                </button>
                <button
                  type="button"
                  className="w-full bg-[#0000000D] p-2 rounded-[5px]"
                  onClick={handleClose}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const DeleteHomeBanner = ({ handleClose, prevBanner }) => {
  const queryClient = useQueryClient();
  const [visible,] = useState(true);

  const mutation = useMutation(deleteBanner, {
    onSuccess: () => {
      queryClient.invalidateQueries("banners-home");
      queryClient.invalidateQueries("banners-shop");
      toast.success("Banner deleted");
      handleClose();
    },
    onError: (e) => {
      toast.error(e.message);
    },
  });

  const onFinish = (e) => {
    e.preventDefault();

    const data = {
      id: prevBanner._id,
    };

    mutation.mutate(data);
  };

  return (
    <div
      className="h-full fixed top-0 right-0"
      style={{ width: "calc(100vw - 260px)" }}
    >
      <div className={"w-full h-full bg-[#00000054] fixed"}></div>
      <div
        className={`relative h-[35%] bg-white top-[50%] translate-y-[-50%] transition-all overflow-hidden ${
          visible ? "w-[80%] opacity-100" : "w-[0%] opacity-50"
        }`}
        style={{ transitionDuration: "500" }}
      >
        <div className="space-y-5 py-10 px-7">
          <div className="flex items-center">
            <div className="m-auto text-[19px] font-bold">Delete Banner</div>
            <button
              className="bg-[#1B0A4B] p-1 rounded-[5px] w-fit"
              onClick={handleClose}
            >
              <FaTimes className="text-white " />
            </button>
          </div>
          <div className="flex justify-center items-center flex-col mt-10">
            <h2>Are you sure you want to delete this banner?</h2>
            <div className="flex items-center w-full font-bold text-[14px] gap-5 py-10">
              <button
                type="button"
                onClick={onFinish}
                className={`w-full bg-[#1B0A4B] p-2 rounded-[5px] text-white ${
                  mutation.isLoading ? "animate-pulse" : ""
                }`}
              >
                {mutation.isLoading ? "Deleting..." : "Continue"}
              </button>
              <button
                type="button"
                className="w-full bg-[#0000000D] p-2 rounded-[5px]"
                onClick={handleClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { HomeBanner, CreateHomeBanner, UpdateHomeBanner, DeleteHomeBanner };
